// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.32.1
// source: robot_interfaces/msg/OperationMode.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "robot_interfaces.msg.pb";

export interface OperationMode {
  mode: OperationMode_ModeEnum;
  armed: boolean;
  emergency_stop: boolean;
  is_moving: boolean;
}

export enum OperationMode_ModeEnum {
  MODE_UNKNOWN = 0,
  MODE_IDLE = 1,
  MODE_ON_MISSION = 2,
  MODE_TELEOPERATION = 3,
  MODE_EXTERNAL_USE = 4,
  UNRECOGNIZED = -1,
}

export function operationMode_ModeEnumFromJSON(object: any): OperationMode_ModeEnum {
  switch (object) {
    case 0:
    case "MODE_UNKNOWN":
      return OperationMode_ModeEnum.MODE_UNKNOWN;
    case 1:
    case "MODE_IDLE":
      return OperationMode_ModeEnum.MODE_IDLE;
    case 2:
    case "MODE_ON_MISSION":
      return OperationMode_ModeEnum.MODE_ON_MISSION;
    case 3:
    case "MODE_TELEOPERATION":
      return OperationMode_ModeEnum.MODE_TELEOPERATION;
    case 4:
    case "MODE_EXTERNAL_USE":
      return OperationMode_ModeEnum.MODE_EXTERNAL_USE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return OperationMode_ModeEnum.UNRECOGNIZED;
  }
}

export function operationMode_ModeEnumToJSON(object: OperationMode_ModeEnum): string {
  switch (object) {
    case OperationMode_ModeEnum.MODE_UNKNOWN:
      return "MODE_UNKNOWN";
    case OperationMode_ModeEnum.MODE_IDLE:
      return "MODE_IDLE";
    case OperationMode_ModeEnum.MODE_ON_MISSION:
      return "MODE_ON_MISSION";
    case OperationMode_ModeEnum.MODE_TELEOPERATION:
      return "MODE_TELEOPERATION";
    case OperationMode_ModeEnum.MODE_EXTERNAL_USE:
      return "MODE_EXTERNAL_USE";
    case OperationMode_ModeEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseOperationMode(): OperationMode {
  return { mode: 0, armed: false, emergency_stop: false, is_moving: false };
}

export const OperationMode: MessageFns<OperationMode> = {
  encode(message: OperationMode, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mode !== 0) {
      writer.uint32(3193100736).int32(message.mode);
    }
    if (message.armed !== false) {
      writer.uint32(2296763624).bool(message.armed);
    }
    if (message.emergency_stop !== false) {
      writer.uint32(2437536784).bool(message.emergency_stop);
    }
    if (message.is_moving !== false) {
      writer.uint32(2076960744).bool(message.is_moving);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OperationMode {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOperationMode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 399137592: {
          if (tag !== 3193100736) {
            break;
          }

          message.mode = reader.int32() as any;
          continue;
        }
        case 287095453: {
          if (tag !== 2296763624) {
            break;
          }

          message.armed = reader.bool();
          continue;
        }
        case 304692098: {
          if (tag !== 2437536784) {
            break;
          }

          message.emergency_stop = reader.bool();
          continue;
        }
        case 259620093: {
          if (tag !== 2076960744) {
            break;
          }

          message.is_moving = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OperationMode {
    return {
      mode: isSet(object.mode) ? operationMode_ModeEnumFromJSON(object.mode) : 0,
      armed: isSet(object.armed) ? globalThis.Boolean(object.armed) : false,
      emergency_stop: isSet(object.emergencyStop)
        ? globalThis.Boolean(object.emergencyStop)
        : isSet(object.emergency_stop)
        ? globalThis.Boolean(object.emergency_stop)
        : false,
      is_moving: isSet(object.isMoving)
        ? globalThis.Boolean(object.isMoving)
        : isSet(object.is_moving)
        ? globalThis.Boolean(object.is_moving)
        : false,
    };
  },

  toJSON(message: OperationMode): unknown {
    const obj: any = {};
    if (message.mode !== 0) {
      obj.mode = operationMode_ModeEnumToJSON(message.mode);
    }
    if (message.armed !== false) {
      obj.armed = message.armed;
    }
    if (message.emergency_stop !== false) {
      obj.emergencyStop = message.emergency_stop;
    }
    if (message.is_moving !== false) {
      obj.isMoving = message.is_moving;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OperationMode>, I>>(base?: I): OperationMode {
    return OperationMode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OperationMode>, I>>(object: I): OperationMode {
    const message = createBaseOperationMode();
    message.mode = object.mode ?? 0;
    message.armed = object.armed ?? false;
    message.emergency_stop = object.emergency_stop ?? false;
    message.is_moving = object.is_moving ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
